/**
 * B2B wholesale application: state-specific tax hints + assemble contact[body] for Shopify contact form.
 */
(function () {
  'use strict';

  /** @type {Record<string, string>} */
  var STATE_TAX_HINTS = {
    AL: "Alabama: resale claims typically require a valid Alabama resale certificate or SST exemption documentation on file.",
    AK: "Alaska: local jurisdictions may impose sales tax; provide any local resale or exemption documentation you use.",
    AZ: "Arizona: provide your TPT license number if claiming resale; exempt transactions may require Arizona-specific forms.",
    AR: "Arkansas: resale usually requires a permit number and valid resale certificate for your business.",
    CA: "California: CDTFA seller's permit or resale certificate as applicable; exempt sales need qualifying exemption certificates.",
    CO: "Colorado: home-rule cities may have separate rules; provide state license and any local documentation you hold.",
    CT: "Connecticut: resale requires a valid CT resale certificate for qualifying purchases.",
    DE: "Delaware: confirm any gross receipts or local obligations that apply to your business.",
    DC: "District of Columbia: provide OTR resale/exemption documentation if claiming exempt status.",
    FL: "Florida: annual resale certificate or other documentation as required for your exemption type.",
    GA: "Georgia: resale requires a valid Georgia sales tax number and resale certificate where applicable.",
    HI: "Hawaii: general excise tax rules apply; provide GET license and exemption documentation if claiming exempt status.",
    ID: "Idaho: resale requires a seller's permit and valid resale certificate for qualifying purchases.",
    IL: "Illinois: provide resale certificate or streamlined exemption as applicable to your purchase type.",
    IN: "Indiana: registered retail merchant certificate and resale documentation as required.",
    IA: "Iowa: permit number and valid resale certificate for tax-exempt wholesale purchases where applicable.",
    KS: "Kansas: resale/exemption certificate and registration as required for your entity type.",
    KY: "Kentucky: resale requires appropriate permit and valid resale certificate on file.",
    LA: "Louisiana: resale certificate and state/local account numbers as applicable (parish rules may apply).",
    ME: "Maine: resale certificate and registration for tax-exempt wholesale purchases where qualified.",
    MD: "Maryland: resale license and exemption certificate as applicable.",
    MA: "Massachusetts: resale/exemption documentation and ST-4 or equivalent as required for your transaction type.",
    MI: "Michigan: sales tax license and valid resale or exemption certificate where applicable.",
    MN: "Minnesota: resale certificate and tax ID as required for wholesale purchases.",
    MS: "Mississippi: permit and resale certificate for qualifying exempt purchases.",
    MO: "Missouri: resale certificate and sales tax license as applicable.",
    MT: "Montana: no statewide sales tax; confirm any local obligations.",
    NE: "Nebraska: resale certificate and sales tax permit where applicable.",
    NV: "Nevada: resale certificate and sales tax permit for qualifying wholesale purchases.",
    NH: "New Hampshire: no statewide sales tax; confirm other business taxes that may apply.",
    NJ: "New Jersey: resale certificate (ST-3/ST-4) and tax ID as applicable.",
    NM: "New Mexico: CRS number and exemption documentation as applicable (gross receipts tax).",
    NY: "New York: resale certificate (ST-120) and sales tax ID as required.",
    NC: "North Carolina: resale certificate and sales and use tax number where applicable.",
    ND: "North Dakota: resale certificate and sales tax permit as applicable.",
    OH: "Ohio: vendor's license and resale/exemption documentation as required.",
    OK: "Oklahoma: sales permit and resale certificate for qualifying purchases.",
    OR: "Oregon: no statewide sales tax; confirm corporate activity or local obligations.",
    PA: "Pennsylvania: resale certificate (REV-1220) and sales tax license as applicable.",
    RI: "Rhode Island: resale permit and certificate for qualifying wholesale purchases.",
    SC: "South Carolina: retail license and resale certificate as applicable.",
    SD: "South Dakota: sales tax license and resale/exemption documentation as required.",
    TN: "Tennessee: resale certificate and sales tax account as applicable.",
    TX: "Texas: resale certificate and Texas sales tax permit number where required for exempt wholesale purchases.",
    UT: "Utah: resale certificate and sales tax license as applicable.",
    VT: "Vermont: resale certificate and business tax account as applicable.",
    VA: "Virginia: resale certificate and sales tax ID as required.",
    WA: "Washington: reseller permit and resale documentation as applicable.",
    WV: "West Virginia: business registration and resale certificate where applicable.",
    WI: "Wisconsin: seller's permit and resale certificate for qualifying purchases.",
    WY: "Wyoming: sales tax license and resale documentation as applicable.",
  };

  function fieldByName(section, name) {
    var els = section.querySelectorAll("input, select, textarea");
    for (var i = 0; i < els.length; i++) {
      if (els[i].name === name) return els[i];
    }
    return null;
  }

  function val(section, name) {
    var el = fieldByName(section, name);
    if (!el) return "";
    if (el.type === "checkbox") return el.checked ? "yes" : "no";
    return (el.value || "").trim();
  }

  function getCountry(section) {
    return val(section, "b2b_ship_country") || "US";
  }

  function getTaxHintForSection(section) {
    var c = getCountry(section);
    if (c === "CA") {
      return "Canada: GST/HST/QST rules vary by province; provide your business number and provincial resale/exemption documentation as applicable.";
    }
    if (c === "OTHER") {
      return "International / other: describe your tax status and exemption documents in the notes. RedCrocus will confirm requirements before approving tax-exempt checkout.";
    }
    var code = val(section, "b2b_shipping_state");
    if (!code) return "Select a state to see summary guidance (not legal advice).";
    var h = STATE_TAX_HINTS[code];
    if (h) return h;
    return (
      code +
      ": provide a valid resale certificate, seller's permit, or other exemption documentation required if you claim tax-exempt wholesale status. RedCrocus may request copies before approving exempt checkout."
    );
  }

  function initStateHint(section) {
    var sel = fieldByName(section, "b2b_shipping_state");
    var country = fieldByName(section, "b2b_ship_country");
    var out = section.querySelector(".js-b2b-tax-hint-text");
    if (!out) return;

    function update() {
      var text = getTaxHintForSection(section);
      out.textContent = text;
      out.hidden = !text;
    }

    if (sel) {
      sel.addEventListener("change", update);
      sel.addEventListener("input", update);
    }
    if (country) {
      country.addEventListener("change", update);
      country.addEventListener("input", update);
    }
    update();
  }

  function initCountry(section) {
    var country = fieldByName(section, "b2b_ship_country");
    var usWrap = section.querySelector(".js-b2b-us-state-wrap");
    var intlWrap = section.querySelector(".js-b2b-intl-region");
    var intlInput = fieldByName(section, "b2b_region_other");
    if (!country || !usWrap || !intlWrap) return;

    function sync() {
      var c = country.value || "US";
      if (c === "US") {
        usWrap.hidden = false;
        intlWrap.hidden = true;
        if (intlInput) intlInput.removeAttribute("required");
        var st = fieldByName(section, "b2b_shipping_state");
        if (st) st.setAttribute("required", "required");
      } else {
        usWrap.hidden = true;
        intlWrap.hidden = false;
        if (intlInput) intlInput.setAttribute("required", "required");
        var st2 = fieldByName(section, "b2b_shipping_state");
        if (st2) {
          st2.removeAttribute("required");
          st2.value = "";
        }
      }
      var hint = section.querySelector(".js-b2b-tax-hint-text");
      if (hint) {
        hint.textContent = getTaxHintForSection(section);
        hint.hidden = !hint.textContent;
      }
    }

    country.addEventListener("change", sync);
    country.addEventListener("input", sync);
    sync();
  }

  function initBillingSame(section) {
    var cb = section.querySelector(".js-b2b-billing-same");
    var extra = section.querySelector(".js-b2b-billing-fields");
    if (!cb || !extra) return;

    function setReq(nm, on) {
      var el = fieldByName(section, nm);
      if (!el) return;
      if (on) el.setAttribute("required", "required");
      else el.removeAttribute("required");
    }

    function sync() {
      extra.hidden = cb.checked;
      if (cb.checked) {
        setReq("b2b_bill_line1", false);
        setReq("b2b_bill_city", false);
        setReq("b2b_bill_state", false);
        setReq("b2b_bill_zip", false);
      } else {
        setReq("b2b_bill_line1", true);
        setReq("b2b_bill_city", true);
        setReq("b2b_bill_state", true);
        setReq("b2b_bill_zip", true);
      }
    }

    cb.addEventListener("change", sync);
    sync();
  }

  function line(label, value) {
    return label + ": " + (value || "—") + "\n";
  }

  function regionLabel(section) {
    var c = getCountry(section);
    if (c === "US") return val(section, "b2b_shipping_state");
    return val(section, "b2b_region_other");
  }

  function buildBody(section) {
    var c = getCountry(section);
    var hint = getTaxHintForSection(section);
    var same = val(section, "b2b_billing_same") === "yes";

    var parts = [];
    parts.push("=== NEW B2B WHOLESALE APPLICATION ===");
    parts.push("Submitted (UTC): " + new Date().toISOString());
    parts.push("");
    parts.push("--- BUSINESS ---");
    parts.push(line("Legal business name", val(section, "b2b_business_legal")));
    parts.push(line("DBA / trade name", val(section, "b2b_dba")));
    parts.push(line("Business type", val(section, "b2b_business_type")));
    parts.push(line("Federal EIN", val(section, "b2b_ein")));
    parts.push(line("Business website", val(section, "b2b_website")));
    parts.push("");
    parts.push("--- PRIMARY CONTACT ---");
    parts.push(line("Name (Shopify contact[name])", val(section, "contact[name]")));
    parts.push(line("Email (Shopify contact[email])", val(section, "contact[email]")));
    parts.push(line("Phone (Shopify contact[phone])", val(section, "contact[phone]")));
    parts.push("");
    parts.push("--- SHIPPING / OPERATIONS ADDRESS ---");
    parts.push(line("Country", c));
    parts.push(line("State / province / region", regionLabel(section)));
    parts.push(line("Street line 1", val(section, "b2b_ship_line1")));
    parts.push(line("Street line 2", val(section, "b2b_ship_line2")));
    parts.push(line("City", val(section, "b2b_ship_city")));
    parts.push(line("Postal code", val(section, "b2b_ship_zip")));
    parts.push("");
    parts.push("--- BILLING ADDRESS ---");
    parts.push(line("Same as shipping", same ? "yes" : "no"));
    if (!same) {
      parts.push(line("Billing street line 1", val(section, "b2b_bill_line1")));
      parts.push(line("Billing street line 2", val(section, "b2b_bill_line2")));
      parts.push(line("Billing city", val(section, "b2b_bill_city")));
      parts.push(line("Billing state / province", val(section, "b2b_bill_state")));
      parts.push(line("Billing postal code", val(section, "b2b_bill_zip")));
    }
    parts.push("");
    parts.push("--- TAX / EXEMPTION (summary — not legal advice) ---");
    parts.push(hint);
    parts.push("");
    parts.push(line("Exemption / resale category", val(section, "b2b_exemption_kind")));
    parts.push(line("State seller's permit / tax ID (if applicable)", val(section, "b2b_state_tax_id")));
    parts.push(line("Resale or exemption certificate # (if applicable)", val(section, "b2b_cert_number")));
    parts.push(line("Tax notes", val(section, "b2b_tax_notes")));
    parts.push("");
    parts.push("--- WHOLESALE PROFILE ---");
    parts.push(line("Estimated monthly plant volume", val(section, "b2b_volume")));
    parts.push(line("Industries served (short)", val(section, "b2b_industries")));
    parts.push(line("How did you hear about RedCrocus?", val(section, "b2b_referral")));
    parts.push("");
    parts.push(line("Applicant confirmed wholesale application", val(section, "b2b_confirm")));
    parts.push("");
    parts.push(
      "Next step: Review in Shopify Admin, create B2B company / location as appropriate, assign catalog, and configure tax exemption. Notifications go to the store contact email — set it to support@redcrocus.com if needed."
    );

    return parts.join("\n");
  }

  function validate(section) {
    var req = [
      ["b2b_business_legal", "Legal business name is required."],
      ["b2b_business_type", "Business type is required."],
      ["b2b_ein", "Federal EIN is required."],
      ["b2b_ship_line1", "Shipping address line 1 is required."],
      ["b2b_ship_city", "City is required."],
      ["b2b_ship_zip", "Postal code is required."],
      ["contact[name]", "Contact name is required."],
      ["contact[email]", "Email is required."],
      ["contact[phone]", "Phone is required."],
      ["b2b_exemption_kind", "Please select an exemption / resale category."],
    ];

    var i;
    for (i = 0; i < req.length; i++) {
      if (!val(section, req[i][0])) return req[i][1];
    }

    var country = getCountry(section);
    if (country === "US" && !val(section, "b2b_shipping_state")) {
      return "Please select a state.";
    }
    if (country !== "US" && !val(section, "b2b_region_other")) {
      return "Please enter state / province / region.";
    }

    if (val(section, "b2b_confirm") !== "yes") {
      return "Please confirm that you are applying for a wholesale / trade account.";
    }

    if (val(section, "b2b_billing_same") !== "yes") {
      if (
        !val(section, "b2b_bill_line1") ||
        !val(section, "b2b_bill_city") ||
        !val(section, "b2b_bill_state") ||
        !val(section, "b2b_bill_zip")
      ) {
        return "Please complete billing address or check Same as shipping.";
      }
    }

    return "";
  }

  function initForm(section) {
    var form = section.querySelector(".js-wholesale-b2b-form");
    var bodyEl = fieldByName(section, "contact[body]");
    if (!form || !bodyEl) return;

    form.addEventListener("submit", function (e) {
      var err = validate(section);
      if (err) {
        e.preventDefault();
        alert(err);
        return;
      }
      bodyEl.value = buildBody(section);
    });
  }

  document.querySelectorAll(".wholesale-b2b-signup").forEach(function (section) {
    initStateHint(section);
    initCountry(section);
    initBillingSame(section);
    initForm(section);
  });
})();
